import React,{useState,useMemo} from "react";
import Helper from '../functions/Helper.js';
import DealRow from './DealRow.js'

const showShopsAmount=3;

export default function PriceComparison(props){
  const [showingMoreShops,setShowingMoreShops]=useState(false);
  let colorways_by_shop=useMemo(()=>Helper.sort_colorways_by_shop(props.shoe.colorways),[props.shoe.colorways])
  return(
    <div style={{maxWidth:500,marginTop:20,}}>
      <div style={{fontSize:20,fontWeight:600}}>
        Price Comparison:
      </div>

      {!props.shoe.hasOwnProperty("colorways")?
        <div style={{display:"flex",alignItems:"center",marginTop:20}}>
          <Spinner animation="border" variant="primary"/>
          <span style={{marginLeft:10}}>...loading shops</span>
        </div>
        :
        <>
          <div style={{marginBottom:15,fontSize:16}}>
            Available at {colorways_by_shop.length} {colorways_by_shop.length===1 ? "shop" : "shops"} | Official Retail Price: ${props.shoe.colorways[0].list_price}
          </div>

          {colorways_by_shop.slice(0, showingMoreShops ? 100 : showShopsAmount).map((colorways,index)=>{
            return(
              <DealRow key={index} style={{borderTopWidth:index===0? 1:0}} trackingId={props.prefix+"_price_comp"} colorway={colorways.colorways[0]}/>
            )}
          )}

          { showingMoreShops &&  colorways_by_shop.length>showShopsAmount  &&
            <div onClick={()=>{setShowingMoreShops(false)}} style={{fontSize:16,cursor:"pointer",color:"var(--primary-color-600)",fontWeight:600,marginTop:10}}>
              <i className="fas fa-arrow-up"/> See less shops
            </div>
          }
          {colorways_by_shop.length===0 &&
            <div>No shops found</div>
          }

          {!showingMoreShops &&  colorways_by_shop.length> showShopsAmount  &&
            <div onClick={()=>{setShowingMoreShops(true)}} style={{fontSize:16,cursor:"pointer",color:"var(--primary-color-600)",fontWeight:600,marginTop:10}}>
              <i className="fas fa-arrow-down"/> See all {colorways_by_shop.length} shops
            </div>
          }
        </>
      }
    </div>

  );
}
